import { AxiosError } from "axios";

function handleAxiosError(err: unknown, defaultMessage: string = "Nastala neočekávaná chyba.", ): string {
    if (err instanceof AxiosError) {
        return err.response?.data?.message || defaultMessage;
    }
    return defaultMessage;
}

export default handleAxiosError;